import { Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';

import './SubmitModal.scss';
import { IsOnlyNumbers } from '../../utils/helpers';
import FormField from '../FormField';
import Button from '../Button';
import SubmitModalWrapper from './SubmitModalWrapper';
import { useUserData } from '../../utils/hooks';

const SubmitModalDescuento = ({ showModal, sendInfo, onClose, colorCode }) => {
  const { 
    saveMinimalUserData, 
    userData, 
    getClientInfoRequest, 
    gometa } = useUserData();
  
  const getClientInfo = (dat, setField) => {
    getClientInfoRequest(dat, ({ data }) => {
      if (!data || !data?.length) {
        return;
      }
      const d = data[0];
      
      if (d?.guess_type === 'DIMEX/NITE') {
        setField('name_client', d.firstname);
        setField('last_name', d.lastname);
      } else if (d?.guess_type !== 'FISICA') {
        setField('name_client', d.fullname);
      } else {
        setField('name_client', d.firstname);
        setField('last_namebu', d.lastname);
      }
    });
  }
  if (!showModal) return null;
  
  return (
      <SubmitModalWrapper
        showModal={showModal} 
        onClose={onClose}
        colorCode={colorCode}
      >
        <Formik
          initialValues={{
            id_real: userData.id || '',
            name_client: userData.name || '',
            email: userData.email || '',
            phone: userData.phone || '',
            last_name: userData.lastName || '',
            politica: 'politica',
          }}
          validationSchema={Yup.object().shape({
            id_real: Yup.string().required('Requerido'),
            name_client: Yup.string().required('Requerido'),
            last_name: Yup.string().required('Requerido'),
            email: Yup.string()
              .email('Ingrese un email válido')
              .required('Requerido'),
            phone: Yup.number().integer().test('len', 'El télefono debe contener 8 digitos y solo números', val => {
              const hasOnlyNumbers = IsOnlyNumbers(val);
              if (!hasOnlyNumbers) {
                return false;
              }
              return !!val && (val).toString().length === 8;
            }),
            politica: Yup.string().required('Requerido'),
          })}
          onSubmit={values => {
            saveMinimalUserData({ 
              email: values.email, 
              name: values.name_client, 
              phone: values.phone, 
              id: values.id_real,
              lastName: values.last_name, 
            })
            sendInfo(values);
          }}
          validateOnMount={true}
        >
          {formik2 => (
            <form className="cotizacion-rapida__form" onSubmit={formik2.handleSubmit}>
              <div
                //className="cotizacion-rapida__form"
                style={{ justifyContent: 'center' }}
              >
                <p className="cotizacion-rapida__header-text">Llená tus datos</p>
                <p className="cotizacion-rapida__header-textfield">Completa los siguientes datos para aplicar el descuento a tu compra.</p>
                <br></br>
                <br></br>
                <div className="cotizacion-rapida__form-item" style={{ zIndex: 10 }}>
                  <FormField
                    id="id_real"
                    name="id_real"
                    type="number"
                    placeholder="Eje: 115550555"
                    onChange={formik2.handleChange}
                    onBlur={formik2.handleBlur}
                    value={formik2.values.id_real}
                    touched={formik2.touched.id_real}
                    error={formik2.errors.id_real}
                    required
                    customLabel={
                      <>
                        <span className="cotizacion-rapida__header-textfield">Número de cédula / pasaporte</span> 
                      </>
                    }
                  />
                </div>
                <br />
                {!gometa?.isLoading && false && <span className="waiting-message waiting-message--search">
                  <Button ui="circular" type="red" button="button" onClick={(e) => {
                    e.preventDefault();
                    if (formik2?.errors?.id_real) {
                      return;
                    }
                    getClientInfo(formik2?.values?.id_real, formik2.setFieldValue);
                  }}>  
                    Buscar
                  </Button>
                </span>}
                {gometa?.isLoading && <span className="cotizacion-rapida__form-waiting-message"> Espera unos segundos y verifica tu información.</span>}
                <br></br>
                <div className="cotizacion-rapida__form-item" style={{ zIndex: 10 }}>
                  <FormField
                    id="name_client"
                    name="name_client"
                    placeholder="Eje: Ana Solano Rojas"
                    onChange={formik2.handleChange}
                    onBlur={formik2.handleBlur}
                    value={formik2.values.name_client}
                    touched={formik2.touched.name_client}
                    error={formik2.errors.name_client}
                    required
                    customLabel={
                      <>
                        <span className="cotizacion-rapida__header-textfield">Nombre</span> 
                      </>
                    }
                  />
                </div>
                <br></br>
                <div className="cotizacion-rapida__form-item" style={{ zIndex: 10 }}>
                  <FormField
                    id="last_name"
                    name="last_name"
                    placeholder="Eje: Solano Rojas"
                    onChange={formik2.handleChange}
                    onBlur={formik2.handleBlur}
                    value={formik2.values.last_name}
                    touched={formik2.touched.last_name}
                    error={formik2.errors.last_name}
                    required
                    customLabel={
                      <>
                        <span className="cotizacion-rapida__header-textfield">Apellidos</span> 
                      </>
                    }
                  />
                </div>
                <br></br>
                <div className="cotizacion-rapida__form-item" style={{ zIndex: 10 }}>
                  <FormField
                    label="Escribe tu email"
                    id="email"
                    name="email"
                    placeholder="Eje: anasol_ro@gmail.com"
                    onChange={formik2.handleChange}
                    onBlur={formik2.handleBlur}
                    value={formik2.values.email}
                    touched={formik2.touched.email}
                    error={formik2.errors.email}
                    required
                    customLabel={
                      <>
                        <span className="cotizacion-rapida__header-textfield">Correo electrónico</span> 
                      </>
                    }
                  />
                </div>
                <br></br>
                <div className="cotizacion-rapida__form-item" style={{ zIndex: 10 }}>
                  <FormField
                    label="Escribe tu telefono"
                    id="phone"
                    name="phone"
                    placeholder="Eje: 8888-8888"
                    onChange={formik2.handleChange}
                    onBlur={formik2.handleBlur}
                    value={formik2.values.phone}
                    touched={formik2.touched.phone}
                    error={formik2.errors.phone}
                    required
                    customLabel={
                      <>
                        <span className="cotizacion-rapida__header-textfield">Número de teléfono</span> 
                      </>
                    }
                  />
                </div>
                <br></br>
                <div className="cotizacion-rapida__form-item" style={{ zIndex: 10 }}>
                  <FormField
                    url="/wp-content/themes/veinsa/files/politicas_de_privacidad.pdf"
                    label=""
                    id="politica"
                    name="politica"
                    type="radio"
                    onChange={formik2.handleChange}
                    onBlur={formik2.handleBlur}
                    value={formik2.values.politica}
                    touched={formik2.touched.politica}
                    error={formik2.errors.politica}
                    options={[
                      {
                        component: (
                          <>
                            <div className="classic-form__field--anchor">
                            *<a target="_blank" href="/wp-content/themes/veinsa/files/politicas_de_privacidad.pdf">ACEPTO POLÍTICAS DE PRIVACIDAD</a> Y <a target="_blank" href="/wp-content/themes/veinsa/files/terminos_condiciones_veinsamotors.pdf">TÉRMINOS Y CONDICIONES</a>
                            </div>
                          </>
                        ),
                        value: 'politica',
                        label: 'Acepto Política de privacidad',
                      },
                    ]}
                  />
                </div>
                <br></br>
                <Button 
                  submit
                  ui="circular"
                  disabled={!formik2.isValid} type="red">
                  Aplicar Descuento
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </SubmitModalWrapper>
  );
};

export default SubmitModalDescuento;